import React from 'react';
import { makeStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import clsx from 'clsx';
import ScissorStateComponent from './ScissorStateComponent';
import TableStateComponent from './TableStateComponent';
import { scissorTypes } from '../../Config/scissorStates'
import { useTranslation } from 'react-i18next';

//workstation tile in the workstation overview
export default function WorkstationTile(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    let boxShadow = ""
    let cursor = "";
    let disabled = false;
    let opacity = 1;
    if (props.active) {
        boxShadow = "0 0 7px " + FlagstoneTheme.palette.primary.main;
    }


    if (props.active === false && props.maximumSelected === true) {
        disabled = true;

        cursor = "not-allowed";
        opacity = "0.4";
    } else {
        cursor = "pointer";

    }

    return (
        <div className={classes.workstation} disabled={disabled} style={{ boxShadow: boxShadow, cursor: cursor, opacity: opacity }} onClick={() => !disabled ? props.activateWorkstation(props.workstation.id) : ''}
        >
            <div className={classes.line}>
                {t("LINE")}
            </div>
            <div className={classes.lineId}>
                {props.workstation.code}
            </div>

            <div className={classes.scissorStateContainer}>
                {// if there is a scissorstatus with name scissorTypes.UPPER
                    props.workstation.scissorStatuses.find(x => x.scissorName && x.scissorName === scissorTypes.UPPER) &&
                    <div className={classes.upperScissor}>
                        <ScissorStateComponent size={"S"} scissorStatus={props.workstation.scissorStatuses.find(x => x.scissorName && x.scissorName === scissorTypes.UPPER)}></ScissorStateComponent>
                    </div>
                }
                {// if there is a scissorstatus with name scissorTypes.LOWER
                    props.workstation.scissorStatuses.find(x => x.scissorName && x.scissorName === scissorTypes.LOWER) &&
                    <div className={classes.lowerScissor}>
                        <ScissorStateComponent size={"S"} scissorStatus={props.workstation.scissorStatuses.find(x => x.scissorName && x.scissorName === scissorTypes.LOWER)}></ScissorStateComponent>
                    </div>
                }
                {// if there is a scissorstatus with name scissorTypes.TABLE
                    props.workstation.scissorStatuses.find(x => x.scissorName && x.scissorName === scissorTypes.TABLE) &&
                    <div className={classes.tableState}>
                        <TableStateComponent size={"S"} tableStatus={props.workstation.scissorStatuses.find(x => x.scissorName && x.scissorName === scissorTypes.TABLE)}></TableStateComponent>
                    </div>
                }
            </div >
            <div className={classes.checkboxContainer}>
                <div className={classes.checkboxDiv}>
                    <Checkbox
                        className={classes.checkBox}
                        disabled={disabled}
                        disableRipple
                        color="default"
                        checked={props.active}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                        onChange={() => props.activateWorkstation(props.workstation.id)}
                    /></div>

            </div>
        </div>
    )
}

const useStyles = makeStyles(() => ({
    play: {
        color: "#5CC958",
        height: "30px",
        width: "30px"
    },
    stop: {
        height: "15px",
        width: "15px",
        backgroundColor: "#D84949",
        borderRadius: "3px",
        margin: "10px",
        marginTop: "8px"
    },
    pause: {
        height: "30px",
        width: "30px",
        color: "#F59127",
        marginLeft: "5px"
    },
    planned: {
        height: "20px",
        width: "20px",
        marginRight: "5px",
        paddingTop: "5px"
    },
    cancel: {
        margin: "10px",
        marginTop: "8px",
        marginLeft: "12px"
    },
    line: {
        color: "#8D8D8D",
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingTop: "25px",
        paddingBottom: "5px"

    },
    lineId: {
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingBottom: "10px"

    },
    scissorStateContainer: {
        height: "60px",
        paddingLeft: "20px",
        paddingRight: "20px",
        marginBottom: "5px"
    },
    stateIcon: {
        float: "left"
    },
    state: {
        float: "left",
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        paddingTop: "7px"
    },
    workstation: {
        width: "200px",
        height: "220px",
        backgroundColor: "white",
        borderRadius: "6px",
        padding: "20px",

        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
    },
    checkboxContainer: {
        width: "200px",
        textAlign: "center"
    },
    checkboxDiv: {
        width: "50px",
        marginLeft: "auto",
        marginRight: "auto"

    },
    checkBox: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        marginTop: "3px"
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
    },
}));